export const SET_CURRENT_REVIEWER = "reviewers/SET_CURRENT_REVIEWER";
export const SET_REVIEWERS = "reviewers/SET_REVIEWERS";
export const SET_IS_FETCHING_REVIEWERS = "reviewers/SET_IS_FETCHING_REVIEWERS";
export const RESET_IS_FETCHING_REVIEWERS =
  "reviewers/RESET_IS_FETCHING_REVIEWERS";
export const CLEAR_REVIEWERS = "reviewers/CLEAR_REVIEWERS";
export const GET_REVIEWERS_REQUEST = "reviewers/GET_REVIEWERS_REQUEST";
export const SET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE =
  "reviewers/SET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE";
export const RESET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE =
  "reviewers/RESET_IS_REVIEWER_ACTIVATION_CONFIRM_ACTIVE";
export const DEACTIVATE_REVIEWER_REQUEST =
  "reviewers/DEACTIVATE_REVIEWER_REQUEST";
export const PASSWORD_FORM_NAME = "reviewers/PASSWORD_FORM_NAME";
export const GET_REVIEWER_REQUEST = "reviewers/GET_REVIEWER_REQUEST";
export const GET_TECHNICIAN_PHYSICIANS_REQUEST =
  "reviewers/GET_TECHNICIAN_PHYSICIANS_REQUEST";



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/reviewers/actionTypes.ts